import React, {useState} from "react";
import {Box, Typography} from "@material-ui/core";
import {artifactCardStyles} from "../../styles/artifact-card.style";

type DetailsProps = {
    title: string;
    description: string;
}

export const Details: React.FC<DetailsProps> = ({title, description}) => {

    const classes = artifactCardStyles();

    const [displayFullDescription, toggleFullDescription] = useState(false);

    // Strip HTML tags to get text length
    const getTextContent = (html: string): string => {
        return html.replace(/<[^>]*>/g, '');
    };

    // Truncate text content and return plain text with ellipsis
    const getTruncatedText = (html: string, maxLength: number): string => {
        const textContent = getTextContent(html);
        return textContent.substring(0, maxLength);
    };

    const textContent = getTextContent(description || '');
    const shouldTruncate = textContent.length > 180;

    return (
        <Box marginTop={2}>
            <Typography color={'textPrimary'} className={classes.artifactTitle}>
                {title}
            </Typography>
            <Typography className={classes.artifactSubtitle}>
                {
                    shouldTruncate && !displayFullDescription &&
                    <>
                        <span dangerouslySetInnerHTML={{ 
                            __html: getTruncatedText(description || '', 180) 
                        }} />
                        <span
                            onClick={() => toggleFullDescription(true)}
                            className={classes.showMore}
                        >
                            {' '}...see more
                        </span>
                    </>
                }
                {
                    (!shouldTruncate || displayFullDescription) &&
                    <span dangerouslySetInnerHTML={{ __html: description || '' }} />
                }
            </Typography>
        </Box>
    )
}
